<template>
  <div class="popup">
    <div class="masktop" @click="postfn"></div>
    <div class="mask">
      <div class="show">
        <a class="link"
          ><img class="showimg" @click="postfn" :src="close_pic"
        /></a>
        <a class="link" @click="gotoPath"
          ><img :src="image" class="show-img"
        /></a>
      </div>
    </div>
  </div>
  <!-- <div class="popup" v-else>
    <div class="masktop1" @click="postfn"></div>
    <div class="mask1">
      <div class="show1">
        <a class="link"
          ><img class="showimg1" @click="postfn" :src="close_pic"
        /></a>
        <a class="link" @click="gotoPath"
          ><img :src="image" class="show-img1"
        /></a>
      </div>
    </div>
  </div> -->
</template>

<script>
import countdown from "@/components/tempcount/countdown.vue";
import { getNewUser } from "../../utils/storage";
export default {
  components: {
    countdown,
  },
  data() {
    return {
      image: "",
      close_pic: require("@/assets/images/ad_close.png"),
      isNewUser: false,
      info: {
        currentTime: new Date(),
        startDate: new Date(1635782400000),
        endDate: new Date(1636646400000),
        isFlag: false, //是否显示
      },
    };
  },
  created() {},
  mounted() {
    this.getImagePath();
  },
  methods: {
    //定义方法
    postfn() {
      //向父组件发射xxx事件
      this.$store.commit("updateShowPost", false);
    },
    gotoPath() {
      if (
        this.$store.state.common.userInfo.blance !== null &&
        this.$store.state.common.userInfo.blance > 0
      ) {
        //materialCenter
        this.$router.push({ path: "/find" });
        this.$store.commit("headerMenuId", 1);
        this.$store.commit("asideMenuId", 1);
      } else {
        if (this.isNewUser) {
          this.$router.push({ path: "/pay" });
        }
      }
      // let routeUrl = this.$router.resolve({ path: "/11huodong" });
      // window.open(routeUrl.href, "_blank");
      // this.$store.commit("updateShowPost", false);
    },
    getImagePath() {
      // this.isNewUser = JSON.parse(getNewUser() != 0 && getNewUser() != 2);
      // this.image = require("@/assets/images/postnew.png");

      //this.image = require("@/assets/images/post_1111.gif");
      // if (
      //   this.$store.state.common.userInfo.blance !== null &&
      //   this.$store.state.common.userInfo.blance > 0
      // ) {
      //   this.isNewUser = false;
      //   this.image = require("@/assets/images/postnew.png");
      // } else {
      //   if (this.isNewUser) {
      //     this.image = require("@/assets/images/userpop.png");
      //   } else {
      //     this.image = require("@/assets/images/postnew.png");
      //   }
      // }
      this.image = require("@/assets/images/postnew.png");
      this.isNewUser = false;
      //this.image ="https://tg.aatuku.com/baseFrame-web/api/search/image/postnew1.png";
    },
  },
};
</script>

<style scoped>
@keyframes rotate {
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}
.popup {
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 0.5s;
}

.masktop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.5;
}

.mask {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0);
  z-index: 1002;
}

.mask .show {
  text-align: center;
  margin: auto;
  background-color: transparent;
}
.show-img {
  width: 460px;
  height: 460px;
  margin: auto;
  object-fit: fill;
}
.mask .show .showimg {
  position: absolute;
  right: -50px;
  top: -30px;
  width: 50px;
}

.masktop1 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.5;
}

.mask1 {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0);
  z-index: 1002;
}

.mask1 .show1 {
  text-align: center;
  margin: auto;
  background-color: transparent;
}
.show-img1 {
  width: 520px;
  height: 730px;
  margin: auto;
  object-fit: fill;
}
.mask1 .show1 .showimg1 {
  position: absolute;
  right: -30px;
  top: -20px;
  width: 50px;
}

.mask .show .showtime {
  position: absolute;
  left: 50%;
  top: 72%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  color: #fff;
}

.link:hover,
.server-table i.el-tooltip:hover {
  cursor: pointer;
  color: #409eff;
}
</style>
